import { api_subscribe_user_path, api_update_subscription_for_cbpt_path } from '../../routes';
import request from './request';

export interface SelectedOffer {
  currentPrice: number;
  billingFrequency: string;
  originalPrice?: number;
  code: string;
}

export interface OfferOption extends Omit<SelectedOffer, 'price'> {
  benefits: string;
  currentPriceDisplayOverride: number;
  billingFrequencyOverride: string;
  header: string;
  isBestValue?: boolean;
  originalPriceDisplayOverride?: number;
  subHeader: string;
  title: string;
}

export interface SubscribeUserParams {
  modal?: string;
  page: string;
  code: string;
  referring_article_id?: string;
  referrer_guid?: string;
  source: string;
  subscription_id?: string;
}

export interface SubscribeUserResponse {
  affiliation: string;
  email: string;
  initialSubscriptionPrice: string;
  offerCode: string;
  productSku: string;
  redirectTo: string;
  stripePlanName: string;
  subscriptionVariant: string;
  trackConversion: boolean;
  userId: number;
}

export async function subscribeUser(params: SubscribeUserParams): Promise<SubscribeUserResponse> {
  const response = await request('post', api_subscribe_user_path(params));
  return response;
}

export async function updateCbptUserSubscription(
  params: SubscribeUserParams
): Promise<SubscribeUserResponse> {
  const response = await request('put', api_update_subscription_for_cbpt_path(params));
  return response;
}
